import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "disabled", "href", "icon", "selected", "text"];

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import React from 'react';
import createNavLink from '../factories/createNavLink';
var rootStyles = process.env.NODE_ENV === "production" ? {
  name: "1qq2uy",
  styles: "display:block;margin:0;padding:8px;list-style:none;& ul{padding:0;}"
} : {
  name: "i22j5e-rootStyles",
  styles: "display:block;margin:0;padding:8px;list-style:none;& ul{padding:0;};label:rootStyles;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL05hdkl0ZW0udHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQXVCbUIiLCJmaWxlIjoiLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvTmF2SXRlbS50c3giLCJzb3VyY2VzQ29udGVudCI6WyIvKiogQGpzeCBqc3ggKi9cblxuaW1wb3J0IHsgY3NzLCBqc3ggfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5pbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xuaW1wb3J0IGNyZWF0ZU5hdkxpbmsgZnJvbSAnLi4vZmFjdG9yaWVzL2NyZWF0ZU5hdkxpbmsnO1xuaW1wb3J0IHR5cGUgeyBIdG1sU3BhblNob3J0aGFuZCB9IGZyb20gJy4uL3R5cGVzJztcblxudHlwZSBPd25Qcm9wcyA9IHtcbiAgY2hpbGRyZW4/OiBSZWFjdC5SZWFjdE5vZGU7XG4gIGRpc2FibGVkPzogYm9vbGVhbjtcbiAgaWNvbj86IHN0cmluZztcbiAgaHJlZj86IHN0cmluZztcbiAgc2VsZWN0ZWQ/OiBib29sZWFuO1xuICB0ZXh0PzogSHRtbFNwYW5TaG9ydGhhbmQ7XG59XG5cbnR5cGUgVW5oYW5kbGVkUHJvcHMgPSBPbWl0PFxuICBSZWFjdC5IVE1MQXR0cmlidXRlczxIVE1MTElFbGVtZW50PixcbiAga2V5b2YgT3duUHJvcHNcbj47XG5cbnR5cGUgUHJvcHMgPSBPd25Qcm9wcyAmIFVuaGFuZGxlZFByb3BzO1xuXG5jb25zdCByb290U3R5bGVzID0gY3NzKHtcbiAgZGlzcGxheTogJ2Jsb2NrJyxcbiAgbWFyZ2luOiAnMCcsXG4gIHBhZGRpbmc6ICc4cHgnLFxuICBsaXN0U3R5bGU6ICdub25lJyxcbiAgJyYgdWwnOiB7XG4gICAgcGFkZGluZzogJzAnLFxuICB9LFxufSk7XG5cbmNvbnN0IE5hdkl0ZW06IFJlYWN0LkZDPFByb3BzPiA9ICh7XG4gIGNoaWxkcmVuLFxuICBkaXNhYmxlZCxcbiAgaHJlZixcbiAgaWNvbixcbiAgc2VsZWN0ZWQsXG4gIHRleHQsXG4gIC4uLnVuaGFuZGxlZFByb3BzXG59KSA9PiAoXG4gIDxsaSB7Li4udW5oYW5kbGVkUHJvcHN9IGNzcz17cm9vdFN0eWxlc30+XG4gICAge2NoaWxkcmVuICE9IG51bGwgPyBjaGlsZHJlbiA6IGNyZWF0ZU5hdkxpbmsoe1xuICAgICAgZGlzYWJsZWQsXG4gICAgICBocmVmLFxuICAgICAgaWNvbixcbiAgICAgIHNlbGVjdGVkLFxuICAgICAgdGV4dCxcbiAgICB9KX1cbiAgPC9saT5cbik7XG5cbmV4cG9ydCBkZWZhdWx0IE5hdkl0ZW07XG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

var NavItem = function NavItem(_ref) {
  var children = _ref.children,
      disabled = _ref.disabled,
      href = _ref.href,
      icon = _ref.icon,
      selected = _ref.selected,
      text = _ref.text,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  return jsx("li", _extends({}, unhandledProps, {
    css: rootStyles
  }), children != null ? children : createNavLink({
    disabled: disabled,
    href: href,
    icon: icon,
    selected: selected,
    text: text
  }));
};

export default NavItem;